import { useState } from 'react';
import { Button } from '@repo/ui/components/button';
import { Input } from '@/components/form/input';
import { Plus } from 'lucide-react';

interface QuantitySelectionStepProps {
  productName: string;
  defaultPrice?: number;
  onConfirm: (quantity: number, price?: number) => void;
}

const QUICK_QUANTITIES = [1, 2, 3, 5, 10];

export function QuantitySelectionStep({
  productName,
  defaultPrice,
  onConfirm,
}: QuantitySelectionStepProps) {
  const [quantity, setQuantity] = useState<string>('1');
  const [price, setPrice] = useState<string>(
    typeof defaultPrice === 'number' ? defaultPrice.toString() : ''
  );

  const handleQuantityChange = (value: string) => {
    // Only allow numbers
    const numValue = value.replace(/[^0-9]/g, '');
    if (numValue === '' || parseInt(numValue) > 0) {
      setQuantity(numValue);
    }
  };

  const handlePriceChange = (value: string) => {
    const normalized = value.replace(',', '.');
    if (/^[0-9]*[.]?[0-9]*$/.test(normalized)) {
      setPrice(normalized);
    }
  };

  const handleQuickSelect = (qty: number) => {
    setQuantity(qty.toString());
  };

  const handleConfirm = () => {
    const qty = parseInt(quantity) || 1;
    const priceNumber =
      price.trim() === '' ? undefined : Number.isNaN(Number(price)) ? undefined : Number(price);

    if (qty > 0 && qty <= 999 && (priceNumber === undefined || priceNumber > 0)) {
      onConfirm(qty, priceNumber);
    }
  };

  const quantityNum = parseInt(quantity) || 1;
  const priceNumber =
    price.trim() === '' ? undefined : Number.isNaN(Number(price)) ? undefined : Number(price);
  const isValid =
    quantityNum > 0 && quantityNum <= 999 && (priceNumber === undefined || priceNumber > 0);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <p className="text-sm text-gray-600">Producto: {productName}</p>
      </div>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">Cantidad</label>
          <Input
            type="number"
            min="1"
            max="999"
            value={quantity}
            onChange={(e) => handleQuantityChange(e.target.value)}
            className="text-2xl! text-center! font-bold!"
            placeholder="1"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">Precio unitario</label>
          <Input
            type="text"
            inputMode="decimal"
            value={price}
            onChange={(e) => handlePriceChange(e.target.value)}
            className="text-xl! text-center!"
            placeholder={defaultPrice !== undefined ? defaultPrice.toString() : 'Precio'}
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">Cantidades rápidas</label>
          <div className="grid grid-cols-5 gap-2">
            {QUICK_QUANTITIES.map((qty) => (
              <Button
                key={qty}
                variant={quantity === qty.toString() ? 'pos' : 'pos-outline'}
                onClick={() => handleQuickSelect(qty)}
              >
                {qty}
              </Button>
            ))}
          </div>
        </div>
      </div>

      <Button onClick={handleConfirm} disabled={!isValid} variant="pos" size="4xl">
        <Plus className="size-5" />
        Agregar producto
      </Button>
    </div>
  );
}
